import { useEffect, useState } from 'react';
import { ACSApi, ToastStateHandler } from '../../../api';
import { LeaveRequestStatus } from '../../../commonTypes/leaveRequest.types';
import { LeaveRequestUserInfoIncluded } from '../../../commonTypes/acs';
import { useContainer } from '../../useContainer';
import { Pageable } from '../../../commonTypes/pageable.types';
import { useTranslation } from '../../useTranslation';

export interface ILeaveRequestSearchParams extends Pageable {
    status?: LeaveRequestStatus;
}

const SIZE = 8;
const DEFAULT_PAGE = 0;

const useHttpGetLeaveRequestsFromOrganizationOMX = (organizationId: string, params?: ILeaveRequestSearchParams) => {
    const { t } = useTranslation('newNotifications');
    const acsApi = useContainer(ACSApi);
    const toastHandler = useContainer(ToastStateHandler);

    const [data, setData] = useState<LeaveRequestUserInfoIncluded[]>([]);
    const [total, setTotal] = useState(0);
    const [isReady, setReady] = useState(false);

    const { exec, abort } = acsApi.getLeaveRequestsFromOrganization({
        query: {
            organizationId,
            size: params?.size ?? SIZE,
            page: params?.page ?? DEFAULT_PAGE,
            ...(params?.status && { status: params.status }),
            sort: 'fromDate',
            direction: 'asc',
        },
        onSuccess: res => {
            setData(res.body.items);
            setTotal(parseInt(res.body.total));
        },
        onError: () => {
            toastHandler.push('error', t('common.error'), t('common.somethingWentWrong'));
        },
        onFinally: () => setReady(true),
    });

    useEffect(() => {
        if (!organizationId) return;
        exec();
        return abort;
    }, [params?.page, params?.status, params?.size]);

    return { exec, data, setData, total, isReady };
};

export default useHttpGetLeaveRequestsFromOrganizationOMX;
